<template>
  <div class="login-wrap">
    <p class="login-logo">{{ $t('Login.signIn') }}</p>
    <div class="login-form">
      <p>{{ $t('Login.email') }}</p>
      <input
        type="text"
        name="email"
        @input="
          (event) => {
            userInputDebounced('email', event);
          }
        "
      />
    </div>
    <div class="login-form">
      <p>{{ $t('Login.password') }}</p>
      <input
        type="password"
        name="password"
        @input="
          (event) => {
            userInputDebounced('password', event);
          }
        "
        @keyup.enter="login"
      />
    </div>
    <div class="login-button">
      <button class="login-blue" @click="() => login()">{{ $t('Login.signIn') }}</button>
      <button class="login-lightblue" @click="() => moveEnroll()">{{ $t('Login.signUp') }}</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      email: '',
      password: '',
      timer: null,
    };
  },
  methods: {
    ...mapActions('login', ['AC_LOGIN']),
    userInputDebounced(part, event) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        if (part === 'email') {
          this.email = event.target.value;
        } else {
          this.password = event.target.value;
        }
      }, 200);
    },
    checkEmailPassword() {
      return (this.email !== '') & (this.password !== '');
    },
    login() {
      if (this.checkEmailPassword()) {
        this.AC_LOGIN({
          email: this.email,
          password: this.password,
        }).then(() => {
          if (this.isLogin) {
            this.$router.go(-1);
          } else {
            this.$emit(
              'showNotice',
              this.$i18n.locale === 'eng'
                ? 'You have entered an incorrect email or password, or your email is not registered.'
                : '이메일 혹은 비밀번호를 잘못 입력하셨거나, 등록되지 않은 이메일 입니다.'
            );
          }
        });
      } else {
        this.$emit(
          'showNotice',
          this.$i18n.locale === 'eng'
            ? 'Enter your email and password.'
            : '이메일과 비밀번호를 입력하세요.'
        );
      }
    },
    moveEnroll() {
      this.$emit('controlMode');
    },
  },
  computed: {
    ...mapState('login', {
      isLogin: (state) => state.isLogin,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
